import React, { useState, useEffect, useRef } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Content from '@/components/specific/Content'
import { useDocumentTitle } from '@/utils/hooks/useDocumentTitle'
import numeral from 'numeral'
import global from '@/utils/helpers/global'
import { getTagihanPelanggan } from '@/utils/apis/public'

// Dummy data berdasarkan sample API
const dummyData = {
  "message": "Request success",
  "data": {
    "pelanggan": {
      "id": "6129beac-d53d-44dd-a4c8-726f08e8d17b",
      "kode_pelanggan": "01003700202",
      "nama_pelanggan": "AAN SUTRISNO, H",
      "alamat": "LAGARUTU INDAH L/15",
      "no_hp": null,
      "email": "0",
      "status": "S1",
      "golongan": {
        "id": "a49b7505-dd85-4958-be7a-ee37f4d0a4f6",
        "nama_golongan": "RUMAH TANGGA 2",
        "kode_golongan": "RA"
      },
      "kabupaten": {
        "id": "21dc7b5e-957d-4f68-8996-796f0106f1c0",
        "nama_kabupaten": "KOTA PALU"
      },
      "kecamatan": {
        "id": "75771c48-7eba-4cd0-a912-970dd40a6230",
        "nama_kecamatan": "MANTIKULORE",
        "id_kabupaten": "21dc7b5e-957d-4f68-8996-796f0106f1c0"
      },
      "kelurahan": {
        "id": "49cac68c-e62b-4541-8365-fe9dbf09ffc5",
        "nama_kelurahan": "VALANGGUNI",
        "id_kabupaten": "21dc7b5e-957d-4f68-8996-796f0106f1c0",
        "id_kecamatan": "75771c48-7eba-4cd0-a912-970dd40a6230"
      }
    },
    "tagihan": [
      {
        "id_bill_invoice": "5a200f15-c905-4668-a0c2-8b4140437ca8",
        "id_bill_order": "5f618e9a-97c5-4ac8-8482-1f952a529560",
        "biaya_layanan": 2500,
        "no_invoice": "002171/INV/II/2021",
        "tanggal_invoice": "2021-02-01",
        "tipe": "Tagihan Air",
        "periode_bulan": 2,
        "periode_tahun": 2021,
        "m3_awal": 2652,
        "m3_akhir": 2652,
        "m3_pemakaian": 0,
        "status": "Belum Lunas",
        "tagihan_pemakaian": 0,
        "biaya_admin": 3000,
        "dana_meter": 4500,
        "denda": 5000,
        "total_invoice": 15000
      },
      {
        "id_bill_invoice": "9bcb444c-88e8-4947-90d3-5a798c73e2a4",
        "id_bill_order": "f252eb5a-5ec1-4a29-b286-5d2940cb4e33",
        "biaya_layanan": 2500,
        "no_invoice": "002095/INV/III/2021",
        "tanggal_invoice": "2021-03-01",
        "tipe": "Tagihan Air",
        "periode_bulan": 3,
        "periode_tahun": 2021,
        "m3_awal": 2652,
        "m3_akhir": 2655,
        "m3_pemakaian": 3,
        "status": "Belum Lunas",
        "tagihan_pemakaian": 27500,
        "biaya_admin": 3000,
        "dana_meter": 4500,
        "denda": 5000,
        "total_invoice": 42500
      },
      {
        "id_bill_invoice": "f21ebfea-1d35-499c-bd09-f3baaf720ffb",
        "id_bill_order": "826c03ab-9e1d-4f06-bb89-fd662b18530d",
        "biaya_layanan": 2500,
        "no_invoice": "002096/INV/IV/2021",
        "tanggal_invoice": "2021-04-01",
        "tipe": "Tagihan Air",
        "periode_bulan": 4,
        "periode_tahun": 2021,
        "m3_awal": 2655,
        "m3_akhir": 2655,
        "m3_pemakaian": 0,
        "status": "Belum Lunas",
        "tagihan_pemakaian": 0,
        "biaya_admin": 3000,
        "dana_meter": 4500,
        "denda": 5000,
        "total_invoice": 15000
      },
      {
        "id_bill_invoice": "77e1740b-96f3-4ce9-815e-7b55141021a0",
        "id_bill_order": "0bd81eb6-1ce7-413f-840e-3c19ee7e01b1",
        "biaya_layanan": 2500,
        "no_invoice": "002101/INV/V/2021",
        "tanggal_invoice": "2021-05-01",
        "tipe": "Tagihan Air",
        "periode_bulan": 5,
        "periode_tahun": 2021,
        "m3_awal": 2655,
        "m3_akhir": 2655,
        "m3_pemakaian": 0,
        "status": "Belum Lunas",
        "tagihan_pemakaian": 0,
        "biaya_admin": 3000,
        "dana_meter": 4500,
        "denda": 5000,
        "total_invoice": 15000
      },
      {
        "id_bill_invoice": "77e1740b-96f3-4ce9-815e-7b55141021a0",
        "id_bill_order": "0bd81eb6-1ce7-413f-840e-3c19ee7e01b1",
        "biaya_layanan": 2500,
        "no_invoice": "002101/INV/V/2021",
        "tanggal_invoice": "2021-05-01",
        "tipe": "Tagihan Air",
        "periode_bulan": 5,
        "periode_tahun": 2020,
        "m3_awal": 2655,
        "m3_akhir": 2655,
        "m3_pemakaian": 0,
        "status": "Belum Lunas",
        "tagihan_pemakaian": 0,
        "biaya_admin": 3000,
        "dana_meter": 4500,
        "denda": 5000,
        "total_invoice": 15000
      },
      {
        "id_bill_invoice": "77e1740b-96f3-4ce9-815e-7b55141021a0",
        "id_bill_order": "0bd81eb6-1ce7-413f-840e-3c19ee7e01b1",
        "biaya_layanan": 2500,
        "no_invoice": "002101/INV/V/2021",
        "tanggal_invoice": "2021-05-01",
        "tipe": "Tagihan Air",
        "periode_bulan": 5,
        "periode_tahun": 2020,
        "m3_awal": 2655,
        "m3_akhir": 2655,
        "m3_pemakaian": 0,
        "status": "Belum Lunas",
        "tagihan_pemakaian": 0,
        "biaya_admin": 3000,
        "dana_meter": 4500,
        "denda": 5000,
        "total_invoice": 15000
      },
    ]
  }
}

function TagihanV2() {
  useDocumentTitle('Info Tagihan - Perumdam AVO')
  
  const location = useLocation()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const history = searchParams.get('history')
  const lastPage = searchParams.get('last_page')
  
  const [searchValue, setSearchValue] = useState(history || '')
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  const previousHistoryRef = useRef(null)

  // Group tagihan by year
  const groupTagihanByYear = (tagihan) => {
    const grouped = {}
    tagihan.forEach(item => {
      const year = item.periode_tahun
      if (!grouped[year]) {
        grouped[year] = []
      }
      grouped[year].push(item)
    })
    return grouped
  }

  // Calculate summary
  const calculateSummary = (tagihan) => {
    const totalAmount = tagihan.reduce((sum, item) => sum + item.total_invoice, 0)
    const unpaidCount = tagihan.filter(item => item.status === 'Belum Lunas').length
    const unpaidAmount = tagihan.filter(item => item.status === 'Belum Lunas').reduce((sum, item) => sum + item.total_invoice, 0)
    return {
      totalAmount,
      unpaidCount,
      unpaidAmount,
      totalCount: tagihan.length
    }
  }

  const loadData = async (kode, preservePage = false) => {
    if (!kode) {
      setError('Mohon masukkan nomor sambung')
      return
    }

    setIsLoading(true)
    setError(null)
    
    try {
      const response = await getTagihanPelanggan(kode)
      
      // Response structure: { success: true, data: { message: "...", data: { pelanggan: {...}, tagihan: [...] } } }
      if (response?.success && response?.data?.data) {
        const apiData = response.data.data
        if (apiData.pelanggan && apiData.tagihan) {
          setData(apiData)
          // Update previousHistoryRef untuk track
          previousHistoryRef.current = kode
          // Update URL dengan history untuk maintain state
          // Jika preservePage true (dari auto-load), keep last_page, jika tidak reset ke 1
          const pageParam = preservePage && lastPage ? `&last_page=${lastPage}` : ''
          navigate(`/info-tagihan?history=${kode}${pageParam}`, { replace: true })
        } else {
          setError('Data pelanggan tidak ditemukan')
          setData(null)
        }
      } else {
        setError(response?.data?.message || 'Data pelanggan tidak ditemukan')
        setData(null)
      }
    } catch (err) {
      console.error('Error fetching data:', err)
      const errorMessage = err?.response?.data?.message || err?.message || 'Terjadi kesalahan saat mengambil data. Pastikan nomor sambung sudah benar.'
      setError(errorMessage)
      setData(null)
    } finally {
      setIsLoading(false)
    }
  }

  const handleSearch = async () => {
    const kode = searchValue.trim()
    await loadData(kode, false)
  }

  // Auto-load data jika ada history di URL
  useEffect(() => {
    if (history && history !== 'null') {
      setSearchValue(history)
      
      // Load jika history berbeda dengan sebelumnya
      // Atau jika data tidak ada (misalnya setelah kembali dari detail)
      if (history !== previousHistoryRef.current) {
        previousHistoryRef.current = history
        loadData(history, true)
      } else if (!data) {
        // Jika history sama tapi data tidak ada, reload
        loadData(history, true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]) // Run when history changes

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch()
    }
  }

  const groupedTagihan = data?.tagihan ? groupTagihanByYear(data.tagihan) : {}
  const summary = data?.tagihan ? calculateSummary(data.tagihan) : null

  return (
    <>
      {/* Hero Section - Full Width, No Gap with Navbar */}
      <div className="relative bg-[#095393] overflow-hidden w-screen z-0" style={{ marginLeft: 'calc(50% - 50vw)', marginRight: 'calc(50% - 50vw)', width: '100vw', maxWidth: '100vw' }}>

          {/* Wavy Pattern at Bottom */}
          <div className="absolute bottom-0 left-0 right-0">
            <svg 
              className="w-full h-16 md:h-24" 
              viewBox="0 0 1200 120" 
              preserveAspectRatio="none"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                d="M0,60 C300,100 600,20 900,60 C1050,80 1150,40 1200,60 L1200,120 L0,120 Z" 
                fill="white" 
                opacity="0.3"
              />
              <path 
                d="M0,80 C300,120 600,40 900,80 C1050,100 1150,60 1200,80 L1200,120 L0,120 Z" 
                fill="white" 
                opacity="0.5"
              />
              <path 
                d="M0,100 C300,140 600,60 900,100 C1050,120 1150,80 1200,100 L1200,120 L0,120 Z" 
                fill="white"
              />
            </svg>
          </div>

        {/* Hero Content */}
        <div className="relative z-10 w-full max-w-6xl mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16 lg:py-20">
          <div className="text-center">
            {/* Title */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6">
              Cek Tagihan Air Anda
            </h1>
            
            {/* Breadcrumb */}
            <div className="flex items-center justify-center gap-2 text-white/90 text-sm md:text-base">
              <Link to="https://perumdamavo.id" className="hover:text-white transition-colors">
                Home
              </Link>
              <span className="text-white/60">/</span>
              <span className="text-white">Cek Tagihan</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <Content showContentHeader={false}>
        <div className="w-full max-w-6xl mx-auto px-0 md:px-6 lg:px-8 -mt-8 md:-mt-12 lg:-mt-16 relative z-20">
          {/* Search Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 md:p-6 mb-6">
          <div className="flex flex-col sm:flex-row gap-3">
            <div className="flex-1">
              <input
                type="text"
                placeholder="Masukkan Nomor Sambung"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                onKeyPress={handleKeyPress}
                className="input input-bordered w-full focus:outline-none focus:ring-2 focus:ring-[#095393] focus:border-transparent"
                disabled={isLoading}
              />
            </div>
            <button
              onClick={handleSearch}
              disabled={isLoading}
              className="btn bg-[#095393] hover:bg-[#074a7a] text-white border-0 px-6 sm:px-8 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? (
                <>
                  <span className="loading loading-spinner loading-sm"></span>
                  <span className="hidden sm:inline">Mencari...</span>
                </>
              ) : (
                <>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                  <span>Cari</span>
                </>
              )}
            </button>
          </div>
          {error && (
            <div className="mt-3 text-sm text-red-600 bg-red-50 p-2 rounded">
              {error}
            </div>
          )}
        </div>

        {/* Loading State */}
        {isLoading && (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
            <div className="flex flex-col items-center justify-center space-y-4">
              <span className="loading loading-spinner loading-lg text-[#095393]"></span>
              <p className="text-gray-600">Memuat data tagihan...</p>
            </div>
          </div>
        )}

        {/* Empty State */}
        {!isLoading && !data && !error && (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12 text-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto text-gray-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <p className="text-gray-600">Masukkan nomor sambung untuk melihat informasi tagihan</p>
          </div>
        )}

        {/* Data Display */}
        {!isLoading && data && (
          <>
            {/* Summary Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5 hover:shadow-md transition-shadow">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <p className="text-gray-600 text-sm mb-1">Total Tagihan Belum Lunas</p>
                    <p className="text-2xl font-bold text-gray-800">
                      Rp. {numeral(summary.unpaidAmount).format('0,0')}
                    </p>
                  </div>
                  <div className="bg-[#095393]/10 p-3 rounded-lg flex-shrink-0 ml-3">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-[#095393]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5 hover:shadow-md transition-shadow">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <p className="text-gray-600 text-sm mb-1">Tagihan Belum Lunas</p>
                    <p className="text-2xl font-bold text-red-600">
                      {summary.unpaidCount}
                    </p>
                  </div>
                  <div className="bg-red-50 p-3 rounded-lg flex-shrink-0 ml-3">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5 hover:shadow-md transition-shadow sm:col-span-2 lg:col-span-1">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <p className="text-gray-600 text-sm mb-1">Total Periode</p>
                    <p className="text-2xl font-bold text-gray-800">
                      {summary.totalCount}
                    </p>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg flex-shrink-0 ml-3">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            {/* Customer Info */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6 overflow-hidden">
              <div className="bg-[#095393] px-4 py-1.5">
                <h2 className="text-sm font-semibold text-white flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                  Data Pelanggan
                </h2>
              </div>
              <div className="px-4 py-3">
                <div className="space-y-0">
                  <div className="flex flex-col sm:flex-row sm:items-center py-1.5 border-b border-gray-100">
                    <div className="sm:w-1/3 mb-0.5 sm:mb-0">
                      <p className="text-gray-500 text-xs font-medium uppercase tracking-wide">Nomor Sambung</p>
                    </div>
                    <div className="sm:w-2/3">
                      <p className="text-gray-900 font-semibold text-sm md:text-base">{data.pelanggan.kode_pelanggan}</p>
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row sm:items-center py-1.5 border-b border-gray-100">
                    <div className="sm:w-1/3 mb-0.5 sm:mb-0">
                      <p className="text-gray-500 text-xs font-medium uppercase tracking-wide">Nama Pelanggan</p>
                    </div>
                    <div className="sm:w-2/3">
                      <p className="text-gray-900 text-sm md:text-base">{data.pelanggan.nama_pelanggan}</p>
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row sm:items-start py-1.5 border-b border-gray-100">
                    <div className="sm:w-1/3 mb-0.5 sm:mb-0">
                      <p className="text-gray-500 text-xs font-medium uppercase tracking-wide">Alamat</p>
                    </div>
                    <div className="sm:w-2/3">
                      <p className="text-gray-900 text-sm md:text-base">{data.pelanggan.alamat}</p>
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row sm:items-center py-1.5 border-b border-gray-100">
                    <div className="sm:w-1/3 mb-0.5 sm:mb-0">
                      <p className="text-gray-500 text-xs font-medium uppercase tracking-wide">Golongan</p>
                    </div>
                    <div className="sm:w-2/3">
                      <span className="inline-block bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-medium">
                        {data.pelanggan.golongan.nama_golongan}
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row sm:items-center py-1.5">
                    <div className="sm:w-1/3 mb-0.5 sm:mb-0">
                      <p className="text-gray-500 text-xs font-medium uppercase tracking-wide">Wilayah</p>
                    </div>
                    <div className="sm:w-2/3">
                      <p className="text-gray-900 text-sm md:text-base">
                        {data.pelanggan.kelurahan.nama_kelurahan}, {data.pelanggan.kecamatan.nama_kecamatan}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Tagihan List by Year */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <div className="bg-[#095393] px-4 py-1.5">
                <h2 className="text-sm font-semibold text-white flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                  </svg>
                  Riwayat Tagihan
                </h2>
              </div>
              <div className="p-4 md:p-6">
                {Object.keys(groupedTagihan).sort((a, b) => b - a).map((year) => (
                  <div key={year} className="mb-4 last:mb-0">
                    <div className="collapse collapse-arrow bg-gray-50 border border-gray-200 rounded-lg">
                      <input type="radio" name="tagihan-accordion" defaultChecked={year === Object.keys(groupedTagihan).sort((a, b) => b - a)[0]} />
                      <div className="collapse-title text-base font-semibold text-gray-800 flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2 text-[#095393]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        Tahun {year}
                      </div>
                      <div className="collapse-content bg-white">
                        <div className="overflow-x-auto">
                          <table className="table table-zebra w-full">
                            <thead>
                              <tr>
                                <th className="text-gray-700 font-semibold">Periode</th>
                                <th className="text-gray-700 font-semibold">No. Invoice</th>
                                <th className="text-gray-700 font-semibold">Pemakaian (m³)</th>
                                <th className="text-gray-700 font-semibold">Total</th>
                                <th className="text-gray-700 font-semibold">Status</th>
                                <th className="text-gray-700 font-semibold text-center">Aksi</th>
                              </tr>
                            </thead>
                            <tbody>
                              {groupedTagihan[year].map((item) => (
                                <tr key={item.id_bill_invoice} className="hover:bg-gray-50">
                                  <td className="font-medium">
                                    {global.convert_month(item.periode_bulan)} {item.periode_tahun}
                                  </td>
                                  <td className="text-sm text-gray-600">{item.no_invoice}</td>
                                  <td>{numeral(item.m3_pemakaian).format('0,0')}</td>
                                  <td className="font-semibold">Rp. {numeral(item.total_invoice).format('0,0')}</td>
                                  <td>
                                    {item.status === 'Lunas' ? (
                                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                        <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                        </svg>
                                        {item.status}
                                      </span>
                                    ) : (
                                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                        <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                        </svg>
                                        {item.status}
                                      </span>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    <Link
                                      to={`/info-tagihan/${item.id_bill_invoice}${data?.pelanggan?.kode_pelanggan ? `?history=${data.pelanggan.kode_pelanggan}${lastPage ? `&last_page=${lastPage}` : ''}` : ''}`}
                                      className="btn btn-sm bg-[#095393] hover:bg-[#074a7a] text-white border-0"
                                    >
                                      <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                      </svg>
                                      Detail
                                    </Link>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
        </div>
      </Content>
    </>
  )
}

export default TagihanV2

